import clsx from 'clsx'

import { Image, Media } from '@tribeplatform/gql-client/types'
import { Image as ImageComponent } from '@tribeplatform/react-components/common'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

export const SquareLogo = ({
  image,
  alt,
  size = 'sm',
}: {
  image: Media
  alt: string
  size?: 'xs' | 'sm' | '3xl'
}) => {
  image = image as Image

  let height
  let width
  let sizeClsx
  image = image as Image

  switch (size) {
    case '3xl':
      height = 128
      width = 128
      sizeClsx = 'h-32 w-32'
      break
    case 'xs':
      height = 24
      width = 24
      sizeClsx = 'h-6 w-6'
      break
    default:
    case 'sm':
      height = 32
      width = 32
      sizeClsx = 'h-8 w-8'
      break
  }

  if (!image?.urls?.small) {
    return (
      <Avatar
        rounded="md"
        name={alt}
        size={size}
        className="square-logo-image"
      />
    )
  }

  return (
    <ImageComponent
      className={clsx(
        'inline-block object-contain square-logo-image',
        sizeClsx,
      )}
      height={height}
      width={width}
      src={image?.urls?.small || '/images/default-icon.svg'}
      alt={alt}
    />
  )
}
